import React from 'react';
import { makeStyles } from 'tss-react/mui';
import OtpInput from 'react18-input-otp';
import { useField } from 'formik';


const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    gap: '21px',
    width: '100%',
  },
  input: {
    color: theme.palette.darkSlate.main,
    fontFamily: 'inherit',
    border: 'none',
    borderRadius: 0,
    fontSize: '26px',
    fontWeight: 700,
    width: '100% !important',
    height: '100%',
    borderBottom: `2px solid ${theme.palette.darkSlate.main}B3`,

    '&:focus': {
      outline: 'none',
      // borderBottom: `2px solid ${theme.palette.darkSlate.main}`,
    }
  },
  inputWrapper: {
    height: '50px',
    maxWidth: '60px',
    width: '100%',
  }
}));


export type CodeInputRawProps = {
  id?: string;
  value: string;
  autoFocus?: boolean;
  setValue: (v: string) => void;
  onSubmit?: () => void;
  codeLength?: number;
  classes?: ReturnType<typeof useStyles>;
};


export const CodeInputRaw: React.VFC<CodeInputRawProps> = ({
  id,
  value,
  setValue,
  onSubmit,
  autoFocus,
  codeLength = 4,
  classes: _classes,
}) => {
  const { classes } = useStyles(undefined, {
    props: {
      classes: _classes
    }
  });

  return (
    <OtpInput
      shouldAutoFocus={autoFocus}
      id={id}
      value={value}
      onChange={setValue}
      onSubmit={onSubmit}
      numInputs={codeLength}
      autoComplete="one-time-code"
      isInputNum

      containerStyle={classes.root}
      inputStyle={classes.input}
      inputProps={{ className: classes.inputWrapper, inputMode: 'numeric' }}
    />
  );
};


export type CodeInputProps = Omit<CodeInputRawProps, 'value' | 'setValue'> & {
  name: string;
};


export const CodeInput: React.VFC<CodeInputProps> = (props) => {
  const [ field, _meta, helpers ] = useField(props.name);

  return (
    <CodeInputRaw
      value={field.value}
      setValue={helpers.setValue}
      {...props}
    />
  );
};
